import React from 'react';
import Avatar from '../types/avatar';
import AvatarPastille from '@/views/components/avatar/Avatar';
import { Tooltip } from '@/views/components/tooltips';
import AvatarOverflowTooltip from './avatar-overflow-tooltip/AvatarOverflowTooltip';

interface AvatarOverflowProps {
  avatars: Avatar[];
}

const AvatarOverflow: React.FC<AvatarOverflowProps> = ({ avatars }) => (
  <Tooltip
    className="custom-tooltip-v2"
    message={<AvatarOverflowTooltip avatars={avatars} />}
    place="top"
    aria-label={avatars.map(a => `${a.fname} ${a.lname}`).join(', ')}
  >
    <div>
      <AvatarPastille>+{avatars.length}</AvatarPastille>
    </div>
  </Tooltip>
);

export default AvatarOverflow;
